import { getOffsetMs } from '../../../utils/timeUtils'
import { useTimeZoneStore } from '../../../store/useTimeZoneStore'

const WW_LABELS = {
  0: 'Cloud development not observed',
  1: 'Clouds dissolving or becoming less developed',
  2: 'State of sky on the whole unchanged',
  3: 'Clouds generally forming or developing',
  4: 'Visibility reduced by smoke',
  5: 'Haze',
  6: 'Widespread dust in suspension in the air',
  7: 'Dust or sand raised by wind at or near the station',
  8: 'Well-developed dust whirl(s) or sand whirl(s)',
  9: 'Duststorm or sandstorm within sight',
  10: 'Mist',
  11: 'Shallow fog or ice fog patches',
  12: 'Shallow fog or ice fog, more or less continuous',
  13: 'Lightning visible, no thunder heard',
  14: 'Precipitation within sight, not reaching ground',
  15: 'Precipitation within sight, distant (> 5 km)',
  16: 'Precipitation within sight, near but not at station',
  17: 'Thunderstorm, but no precipitation',
  18: 'Squalls at or within sight of the station',
  19: 'Funnel cloud(s)',
  20: 'Drizzle or snow grains (past hour, not shower)',
  21: 'Rain (past hour, not shower)',
  22: 'Snow (past hour, not shower)',
  23: 'Rain and snow or ice pellets (past hour)',
  24: 'Freezing drizzle or freezing rain (past hour)',
  25: 'Shower(s) of rain (past hour)',
  26: 'Shower(s) of snow, or rain and snow (past hour)',
  27: 'Shower(s) of hail, or rain and hail (past hour)',
  28: 'Fog or ice fog (past hour)',
  29: 'Thunderstorm with or without precipitation (past hour)',
  30: 'Slight or moderate duststorm or sandstorm, decreasing',
  31: 'Slight or moderate duststorm or sandstorm, no change',
  32: 'Slight or moderate duststorm or sandstorm, increasing',
  33: 'Severe duststorm or sandstorm, decreasing',
  34: 'Severe duststorm or sandstorm, no change',
  35: 'Severe duststorm or sandstorm, increasing',
  36: 'Slight or moderate drifting snow, low (below eye level)',
  37: 'Heavy drifting snow, low (below eye level)',
  38: 'Slight or moderate blowing snow, high (above eye level)',
  39: 'Heavy blowing snow, high (above eye level)',
  40: 'Fog or ice fog at a distance, not at station during preceding hour',
  41: 'Fog or ice fog in patches',
  42: 'Fog or ice fog, sky visible, thinning',
  43: 'Fog or ice fog, sky invisible, thinning',
  44: 'Fog or ice fog, sky visible, no change',
  45: 'Fog or ice fog, sky invisible, no change',
  46: 'Fog or ice fog, sky visible, thickening',
  47: 'Fog or ice fog, sky invisible, thickening',
  48: 'Fog depositing rime, sky visible',
  49: 'Fog depositing rime, sky invisible',
  50: 'Drizzle, not freezing, slight, intermittent',
  51: 'Drizzle, not freezing, slight, continuous',
  52: 'Drizzle, not freezing, moderate, intermittent',
  53: 'Drizzle, not freezing, moderate, continuous',
  54: 'Drizzle, not freezing, heavy, intermittent',
  55: 'Drizzle, not freezing, heavy, continuous',
  56: 'Freezing drizzle, slight',
  57: 'Freezing drizzle, moderate or heavy',
  58: 'Drizzle and rain, slight',
  59: 'Drizzle and rain, moderate or heavy',
  60: 'Rain, not freezing, slight, intermittent',
  61: 'Rain, not freezing, slight, continuous',
  62: 'Rain, not freezing, moderate, intermittent',
  63: 'Rain, not freezing, moderate, continuous',
  64: 'Rain, not freezing, heavy, intermittent',
  65: 'Rain, not freezing, heavy, continuous',
  66: 'Freezing rain, slight',
  67: 'Freezing rain, moderate or heavy',
  68: 'Rain or drizzle and snow, slight',
  69: 'Rain or drizzle and snow, moderate or heavy',
  70: 'Snowflakes, slight, intermittent',
  71: 'Snowflakes, slight, continuous',
  72: 'Snowflakes, moderate, intermittent',
  73: 'Snowflakes, moderate, continuous',
  74: 'Snowflakes, heavy, intermittent',
  75: 'Snowflakes, heavy, continuous',
  76: 'Diamond dust (with or without fog)',
  77: 'Snow grains (with or without fog)',
  78: 'Isolated star-like snow crystals (with or without fog)',
  79: 'Ice pellets',
  80: 'Rain shower(s), slight',
  81: 'Rain shower(s), moderate or heavy',
  82: 'Rain shower(s), violent',
  83: 'Shower(s) of rain and snow mixed, slight',
  84: 'Shower(s) of rain and snow mixed, moderate or heavy',
  85: 'Snow shower(s), slight',
  86: 'Snow shower(s), moderate or heavy',
  87: 'Shower(s) of snow pellets or small hail, slight',
  88: 'Shower(s) of snow pellets or small hail, moderate or heavy',
  89: 'Shower(s) of hail, not associated with thunder, slight',
  90: 'Shower(s) of hail, not associated with thunder, moderate or heavy',
  91: 'Slight rain; thunderstorm during preceding hour',
  92: 'Moderate or heavy rain; thunderstorm during preceding hour',
  93: 'Slight snow, rain and snow or hail; thunderstorm during preceding hour',
  94: 'Moderate or heavy snow, rain and snow or hail; thunderstorm during preceding hour',
  95: 'Thunderstorm, slight or moderate, with rain and/or snow',
  96: 'Thunderstorm, slight or moderate, with hail',
  97: 'Thunderstorm, heavy, with rain and/or snow',
  98: 'Thunderstorm combined with duststorm or sandstorm',
  99: 'Thunderstorm, heavy, with hail',
  100: 'No significant weather observed',
  101: 'Clouds dissolving during the past hour',
  102: 'State of sky unchanged during the past hour',
  103: 'Clouds forming during the past hour',
  104: 'Haze or smoke or dust, visibility ≥ 1 km',
  105: 'Haze or smoke or dust, visibility < 1 km',
  110: 'Mist',
  111: 'Diamond dust',
  112: 'Distant lightning',
  118: 'Squalls',
  120: 'Fog (past hour)',
  121: 'Precipitation (past hour)',
  122: 'Drizzle or snow grains (past hour)',
  123: 'Rain, not freezing (past hour)',
  124: 'Snow (past hour)',
  125: 'Freezing drizzle or freezing rain (past hour)',
  126: 'Thunderstorm with or without precipitation (past hour)',
  127: 'Blowing or drifting snow or sand',
  128: 'Blowing or drifting snow or sand, visibility ≥ 1 km',
  129: 'Blowing or drifting snow or sand, visibility < 1 km',
  130: 'Fog',
  131: 'Fog or ice fog in patches',
  132: 'Fog or ice fog, thinning during past hour',
  133: 'Fog or ice fog, no change during past hour',
  134: 'Fog or ice fog, thickening during past hour',
  135: 'Fog depositing rime',
  140: 'Precipitation',
  141: 'Precipitation, slight or moderate',
  142: 'Precipitation, heavy',
  143: 'Liquid precipitation, slight or moderate',
  144: 'Liquid precipitation, heavy',
  145: 'Solid precipitation, slight or moderate',
  146: 'Solid precipitation, heavy',
  147: 'Freezing precipitation, slight or moderate',
  148: 'Freezing precipitation, heavy',
  150: 'Drizzle',
  151: 'Drizzle, not freezing, slight',
  152: 'Drizzle, not freezing, moderate',
  153: 'Drizzle, not freezing, heavy',
  154: 'Drizzle, freezing, slight',
  155: 'Drizzle, freezing, moderate',
  156: 'Drizzle, freezing, heavy',
  157: 'Drizzle and rain, slight',
  158: 'Drizzle and rain, moderate or heavy',
  160: 'Rain',
  161: 'Rain, not freezing, slight',
  162: 'Rain, not freezing, moderate',
  163: 'Rain, not freezing, heavy',
  164: 'Rain, freezing, slight',
  165: 'Rain, freezing, moderate',
  166: 'Rain, freezing, heavy',
  167: 'Rain (or drizzle) and snow, slight',
  168: 'Rain (or drizzle) and snow, moderate or heavy',
  170: 'Snow',
  171: 'Snow, slight',
  172: 'Snow, moderate',
  173: 'Snow, heavy',
  174: 'Ice pellets, slight',
  175: 'Ice pellets, moderate',
  176: 'Ice pellets, heavy',
  177: 'Snow grains',
  178: 'Ice crystals',
  180: 'Shower(s) or intermittent precipitation',
  181: 'Rain shower(s) or intermittent rain, slight',
  182: 'Rain shower(s) or intermittent rain, moderate',
  183: 'Rain shower(s) or intermittent rain, heavy',
  184: 'Rain shower(s) or intermittent rain, violent',
  185: 'Snow shower(s) or intermittent snow, slight',
  186: 'Snow shower(s) or intermittent snow, moderate',
  187: 'Snow shower(s) or intermittent snow, heavy',
  189: 'Hail',
  190: 'Thunderstorm',
  191: 'Thunderstorm, slight or moderate, no precipitation',
  192: 'Thunderstorm, slight or moderate, with rain/snow showers',
  193: 'Thunderstorm, slight or moderate, with hail',
  194: 'Thunderstorm, heavy, no precipitation',
  195: 'Thunderstorm, heavy, with rain/snow showers',
  196: 'Thunderstorm, heavy, with hail',
  199: 'Tornado',
  204: 'Volcanic ash suspended in the air aloft',
  206: 'Thick dust haze, visibility < 1 km',
  207: 'Blowing spray at the station',
  208: 'Drifting dust (sand)',
  209: 'Wall of dust or sand in distance (haboob)',
  210: 'Snow haze',
  211: 'Whiteout',
  213: 'Lightning, cloud to surface',
  217: 'Dry thunderstorm',
  219: 'Tornado cloud at or within sight of the station',
  220: 'Deposition of volcanic ash',
  221: 'Deposition of dust or sand',
  222: 'Deposition of dew',
  223: 'Deposition of wet snow',
  224: 'Deposition of soft rime',
  225: 'Deposition of hard rime',
  226: 'Deposition of hoar frost',
  227: 'Deposition of glaze',
  228: 'Deposition of ice crust (ice slick)',
  230: 'Duststorm or sandstorm, temperature below 0 °C',
  239: 'Blowing snow, impossible to determine if falling',
  241: 'Fog on sea',
  242: 'Fog in valleys',
  243: 'Arctic or Antarctic sea smoke',
  244: 'Steam fog (sea, lake or river)',
  245: 'Steam fog (land)',
  246: 'Fog over ice or snow cover',
  247: 'Dense fog, visibility 60–90 m',
  248: 'Dense fog, visibility 30–60 m',
  249: 'Dense fog, visibility < 30 m',
  250: 'Drizzle, rate < 0.10 mm/h',
  251: 'Drizzle, rate 0.10–0.19 mm/h',
  252: 'Drizzle, rate 0.20–0.39 mm/h',
  253: 'Drizzle, rate 0.40–0.79 mm/h',
  254: 'Drizzle, rate 0.80–1.59 mm/h',
  255: 'Drizzle, rate 1.60–3.19 mm/h',
  256: 'Drizzle, rate 3.20–6.39 mm/h',
  257: 'Drizzle, rate ≥ 6.4 mm/h',
  259: 'Drizzle and snow',
  260: 'Rain, rate < 1.0 mm/h',
  261: 'Rain, rate 1.0–1.9 mm/h',
  262: 'Rain, rate 2.0–3.9 mm/h',
  263: 'Rain, rate 4.0–7.9 mm/h',
  264: 'Rain, rate 8.0–15.9 mm/h',
  265: 'Rain, rate 16.0–31.9 mm/h',
  266: 'Rain, rate 32.0–63.9 mm/h',
  267: 'Rain, rate ≥ 64.0 mm/h',
  270: 'Snow, rate < 1.0 cm/h',
  271: 'Snow, rate 1.0–1.9 cm/h',
  272: 'Snow, rate 2.0–3.9 cm/h',
  273: 'Snow, rate 4.0–7.9 cm/h',
  274: 'Snow, rate 8.0–15.9 cm/h',
  275: 'Snow, rate 16.0–31.9 cm/h',
  276: 'Snow, rate 32.0–63.9 cm/h',
  277: 'Snow, rate ≥ 64.0 cm/h',
  278: 'Snow or ice crystal precipitation from a clear sky',
  279: 'Wet snow, freezing on contact',
  280: 'Precipitation of rain',
  281: 'Precipitation of freezing rain',
  282: 'Precipitation of rain and snow mixed',
  283: 'Precipitation of snow',
  284: 'Precipitation of snow pellets or small hail',
  285: 'Precipitation of snow pellets or small hail, with rain',
  286: 'Precipitation of snow pellets or small hail, with rain and snow mixed',
  287: 'Precipitation of snow pellets or small hail, with snow',
  288: 'Precipitation of hail',
  289: 'Precipitation of hail, with rain',
  290: 'Precipitation of hail, with rain and snow mixed',
  291: 'Precipitation of hail, with snow',
  292: 'Shower(s) or thunderstorm over sea',
  293: 'Shower(s) or thunderstorm over mountains',
  508: 'No significant phenomenon to report',
  509: 'No observation, data not available',
  510: 'Present and past weather missing but expected',
  511: 'Missing value',
}

export function wwLabel(v) {
  return WW_LABELS[Math.round(v)] ?? ''
}

export function visibilityLabel(v) {
  const code = Math.round(v)
  if (code === 0)                return '< 0.1'
  if (code >= 1  && code <= 50) return (code * 0.1).toFixed(1)
  if (code >= 51 && code <= 55) return '—'
  if (code >= 56 && code <= 80) return String(code - 50)
  if (code >= 81 && code <= 88) return String([35, 40, 45, 50, 55, 60, 65, 70][code - 81])
  if (code === 89)               return '> 70'
  if (code === 90)               return '< 0.05'
  if (code === 91)               return '0.05'
  if (code === 92)               return '0.2'
  if (code === 93)               return '0.5'
  if (code === 94)               return '1'
  if (code === 95)               return '2'
  if (code === 96)               return '4'
  if (code === 97)               return '10'
  if (code === 98)               return '20'
  if (code === 99)               return '≥ 50'
  return '—'
}

const W_LABELS = {
  0:  'Cloud covering 1/2 or less of the sky throughout',
  1:  'Cloud covering > 1/2 during part and ≤ 1/2 during part of the period',
  2:  'Cloud covering more than 1/2 of the sky throughout',
  3:  'Sandstorm, duststorm or blowing snow',
  4:  'Fog or ice fog or thick haze',
  5:  'Drizzle',
  6:  'Rain',
  7:  'Snow, or rain and snow mixed',
  8:  'Shower(s)',
  9:  'Thunderstorm(s) with or without precipitation',
  10: 'No significant weather observed',
  11: 'Visibility reduced',
  12: 'Blowing phenomena, visibility reduced',
  13: 'Fog',
  14: 'Precipitation',
  15: 'Drizzle',
  16: 'Rain',
  17: 'Snow or ice pellets',
  18: 'Showers or intermittent precipitation',
  19: 'Thunderstorm',
  31: 'Missing value',
}

export function wLabel(v) {
  return W_LABELS[Math.round(v)] ?? ''
}

export function cldWindVal2Time10M(v, time) {
  if (v == null || time == null) return '—'
  const rowDate = new Date(`${String(time).replace(' ', 'T')}:00Z`)
  if (Number.isNaN(rowDate.getTime())) return '—'
  const resultMs = rowDate.getTime() - 10 * 60 * 1000 + Math.round(v) * 1000
  const resultUtc = new Date(Math.round(resultMs / 60000) * 60000)
  const tz = useTimeZoneStore.getState().tz
  const local = new Date(resultUtc.getTime() + getOffsetMs(resultUtc, tz))
  const h = String(local.getUTCHours()).padStart(2, '0')
  const m = String(local.getUTCMinutes()).padStart(2, '0')
  return `${h}:${m}`
}

export function cldWindVal2TimeHLY(v, time) {
  if (v == null) return '—'
  const hhmm = Math.round(v)
  const h = Math.trunc(hhmm / 100)
  const m = hhmm % 100
  const plain = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
  // Neplatná/mimo rozsah hodnota (h>=24, m>=60) — nezkoušet TZ převod, vrátit surový čas.
  if (time == null || h < 0 || h > 23 || m < 0 || m > 59) return plain
  const dateStr = typeof time === 'string' ? time.slice(0, 10) : ''
  const utcDate = new Date(`${dateStr}T${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00Z`)
  if (Number.isNaN(utcDate.getTime())) return plain
  const tz = useTimeZoneStore.getState().tz
  const local = new Date(utcDate.getTime() + getOffsetMs(utcDate, tz))
  return `${String(local.getUTCHours()).padStart(2, '0')}:${String(local.getUTCMinutes()).padStart(2, '0')}`
}

export function cldWindVal2TimeDLY(v) {
  if (v == null) return '—'
  const hhmm = Math.round(v)
  const h = Math.trunc(hhmm / 100)
  const m = hhmm % 100
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

// min = lower bound (inclusive); array ordered highest→lowest so find() returns first match
export const PRECIP_SCALE = [
  { label: '> 20 mm',      bg: '#1a237e', text: '#fff', min: 20 },
  { label: '10 – 20 mm',   bg: '#283593', text: '#fff', min: 10 },
  { label: '5 – 10 mm',    bg: '#1565c0', text: '#fff', min: 5  },
  { label: '2.5 – 5 mm',   bg: '#1976d2', text: '#fff', min: 2.5 },
  { label: '1 – 2.5 mm',   bg: '#42a5f5', text: '#000', min: 1  },
  { label: '0.5 – 1 mm',   bg: '#90caf9', text: '#000', min: 0.5 },
  { label: '0.1 – 0.5 mm', bg: '#bbdefb', text: '#000', min: 0.1 },
]

export const TEMP_SCALE = [
  { label: '> 35 °C',       bg: '#c62828', text: '#fff', min: 35 },
  { label: '30 – 35 °C',    bg: '#ff7043', text: '#000', min: 30 },
  { label: '25 – 30 °C',    bg: '#ffb74d', text: '#000', min: 25 },
  { label: '20 – 25 °C',    bg: '#fff176', text: '#000', min: 20 },
  { label: '10 – 20 °C',    bg: '#c5e1a5', text: '#000', min: 10 },
  { label: '0 – 10 °C',     bg: '#80cbc4', text: '#000', min: 0 },
  { label: '−10 – 0 °C',    bg: '#81d4fa', text: '#000', min: -10 },
  { label: '−20 – −10 °C',  bg: '#1976d2', text: '#fff', min: -20 },
  { label: '< −20 °C',      bg: '#0d47a1', text: '#fff', min: -Infinity },
]

export const SNOW_SCALE = [
  { label: '> 60 cm',    bg: '#0d2b6e', text: '#fff', min: 60 },
  { label: '31 – 60 cm', bg: '#1565c0', text: '#fff', min: 31 },
  { label: '16 – 30 cm', bg: '#1e88e5', text: '#fff', min: 16 },
  { label: '6 – 15 cm',  bg: '#64b5f6', text: '#000', min: 6  },
  { label: '1 – 5 cm',   bg: '#b3e5fc', text: '#000', min: 1  },
  { label: '0.1 – 1 cm', bg: '#e1f5fe', text: '#000', min: 0.1 },
]

export const SNOW_NEW_SCALE = [
  { label: '> 20 cm',    bg: '#880e4f', text: '#fff', min: 20 },
  { label: '10 – 20 cm', bg: '#c62828', text: '#fff', min: 10 },
  { label: '5 – 10 cm',  bg: '#e53935', text: '#fff', min: 5  },
  { label: '2 – 5 cm',   bg: '#ef9a9a', text: '#000', min: 2  },
  { label: '0.1 – 2 cm', bg: '#fce4ec', text: '#000', min: 0.1 },
]

export const SUN_SCALE = [
  { label: '> 10 hod.',    bg: '#e65100', text: '#fff', min: 10 },
  { label: '8 – 10 hod.',  bg: '#f57c00', text: '#fff', min: 8  },
  { label: '6 – 8 hod.',   bg: '#ffa726', text: '#000', min: 6  },
  { label: '4 – 6 hod.',   bg: '#ffcc02', text: '#000', min: 4  },
  { label: '2 – 4 hod.',   bg: '#fff9c4', text: '#000', min: 2  },
  { label: '0.1 – 2 hod.', bg: '#f5f5f5', text: '#000', min: 0.1 },
]

export const RAD_SCALE = [
  { label: '> 29 000',         bg: '#4a148c', text: '#fff', min: 29000 },
  { label: '27 000 – 29 000',  bg: '#880e4f', text: '#fff', min: 27000 },
  { label: '25 000 – 27 000',  bg: '#c62828', text: '#fff', min: 25000 },
  { label: '22 000 – 25 000',  bg: '#e53935', text: '#fff', min: 22000 },
  { label: '18 000 – 22 000',  bg: '#f4511e', text: '#fff', min: 18000 },
  { label: '14 000 – 18 000',  bg: '#ff7043', text: '#000', min: 14000 },
  { label: '10 000 – 14 000',  bg: '#ffa726', text: '#000', min: 10000 },
  { label: '7 000 – 10 000',   bg: '#ffca28', text: '#000', min: 7000  },
  { label: '4 000 – 7 000',    bg: '#fff176', text: '#000', min: 4000  },
  { label: '2 000 – 4 000',    bg: '#fff9c4', text: '#000', min: 2000  },
  { label: '500 – 2 000',      bg: '#f5f5f5', text: '#000', min: 500   },
  { label: '< 500',            bg: '#e0e0e0', text: '#000', min: 0     },
]

export const WIND_SCALE = [
  { label: '> 28 m/s',    bg: '#4a148c', text: '#fff', min: 28 },
  { label: '20 – 28 m/s', bg: '#c62828', text: '#fff', min: 20 },
  { label: '13 – 20 m/s', bg: '#e64a19', text: '#fff', min: 13 },
  { label: '7 – 13 m/s',  bg: '#ff8f00', text: '#000', min: 7  },
  { label: '3 – 7 m/s',   bg: '#fdd835', text: '#000', min: 3  },
  { label: '< 3 m/s',     bg: '#c8e6c9', text: '#000', min: 0  },
]

export const HUMID_SCALE = [
  { label: '> 92 %',    bg: '#0d47a1', text: '#fff', min: 92 },
  { label: '85 – 92 %', bg: '#1976d2', text: '#fff', min: 85 },
  { label: '75 – 85 %', bg: '#64b5f6', text: '#000', min: 75 },
  { label: '60 – 75 %', bg: '#a5d6a7', text: '#000', min: 60 },
  { label: '40 – 60 %', bg: '#e6ee9c', text: '#000', min: 40 },
  { label: '< 40 %',    bg: '#fff9c4', text: '#000', min: 0  },
]
